import React from 'react';
import PropTypes from 'prop-types';

const INSERT_ITEM_ID = 'INSERT_ITEM_ID';

/**
 * GelboxConrols:
 *  - The layer over the Gelbox image
 *    Used to  handle click event on centrifuge lid and controls panel area
 */
export function GelboxControls(props) {
  let lidBlockPosition = {height: '100px', top: '63px'};

  if (props.open) {
    lidBlockPosition = {
      height: '157px',
      top: '2px',
    };
  }

  const onClick = (callback) => (event) => {
    event.stopPropagation();
    callback();
  };

  const onDragOver = (event) => event.preventDefault();

  const onDrop = (event) => {
    const insertItemId = parseInt(event.dataTransfer.getData(INSERT_ITEM_ID));
    props.onInsertItem({
      itemId: insertItemId,
    });
  };

  const renderDropZone = () => {
    return (
      props.isOpen && (
        <div
          className='gelbox_mouth'
          onDragOver={onDragOver}
          onDrop={onDrop}
          onClick={onClick(props.openBalanceTubeModal)}>
        </div>
      )
    );
  };

  return (
    <>
      <div
        className='gelbox_lidblock'
        onClick={onClick(props.toggleLid)}
        style={lidBlockPosition}
      />
      {renderDropZone()}
    </>
  );
}

GelboxControls.propTypes = {
  /**
   * Boolean to set if lid is open/closed
   */
  open: PropTypes.bool,
  /**
   * Function to invoke to open/close lid
   */
  toggleLid: PropTypes.func,
  /**
   * Function to invoke to open digital controls panel
   */
  openControls: PropTypes.func,
  /**
   * Function to invoke when an item is dropped into the centrifuge
   */
  onInsertItem: PropTypes.func,
  /**
   * Function to invoke open the balancing modal window
   */
  openBalanceTubeModal: PropTypes.func,
  /**
   * List of tubes visible in Front-View of Apparatus
   */
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Type of Tube placed in slot
       */
      tubeType: PropTypes.string,
      /**
       * boolean to specify if solution placed
       */
      solution: PropTypes.bool,
      /**
       * Boolean to specify if rotor placed
       */
      rotor: PropTypes.bool,
    })
  ),
};

GelboxControls.defaultProps = {};
